import { css, cva } from '@/styled-system/css';

export const tabStyles = css.raw({
  borderColor: 'bg.neutral',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  minWidth: 'auto',
  height: 'auto',
  lineHeight: 1,
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  '&[aria-selected="false"]': {
    justifyContent: 'center',
  },
  md: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    paddingBottom: '400',
  },
  '&[aria-selected="true"]': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',
    md: {
      paddingBottom: '400',
    },
  },
});

export const navItemContainerRecipe = cva({
  base: {
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    md: { width: '131px' },
  },
  variants: {
    isInMenuPopper: {
      true: { width: '100%', display: 'flex' },
      false: {},
    },
  },
  defaultVariants: {
    isInMenuPopper: false,
  },
});

export const navItemContentRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
  },
  variants: {
    isActive: {
      true: { color: 'text.accent.brand.hero' },
      false: { color: 'text.subtle' },
    },
    isInMenuPopper: {
      true: { flexDirection: 'row' },
      false: { flexDirection: 'column' },
    },
  },
  defaultVariants: {
    isActive: false,
    isInMenuPopper: false,
  },
});

export const navItemTextRecipe = cva({
  base: {
    color: 'inherit',
  },
  variants: {
    isActive: {
      true: {
        textStyle: 'body-xs-bold',
        mobile390: { textStyle: 'body-sm' },
        md: { textStyle: 'body-bold' },
      },
      false: {
        textStyle: 'body-xs',
        mobile390: { textStyle: 'body-sm' },
        md: { textStyle: 'body' },
      },
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

export const navigationContainerStyles = css.raw({ backgroundColor: 'bg.neutral', paddingTop: '400' });

export const tabsListStyles = css.raw({ gap: 0 });

export const navItemMarginStyles = css.raw({ marginBottom: 0 });

export const moreMenuContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  paddingRight: '400',
  alignItems: 'center',
});

export const moreMenuLabelContainerStyles = css.raw({ marginBottom: '400' });

export const moreMenuLabelTextStyles = css.raw({
  color: 'text.subtle',
  textStyle: 'body-xs',
  mobile390: {
    textStyle: 'body-sm',
  },
});
